import { useEffect, useRef, useState } from 'react';

const AdditionalDocs = (props) => {
  const isReadonly = props.urlparams.params.readonly === 'true' ? true : false;
  const applId = props.urlparams.params.id;
  const additionalDocForm = useRef(null);
  const [additionalDocs, setAdditionalDocs] = useState([]);
  const [additionalDocFields, setAdditionalDocFields] = useState([
    {
      docType: '',
      fileName: '',
      fileId: '',
    },
  ]);

  const addMoreDocs = () => {
    setAdditionalDocFields([
      ...additionalDocFields,
      {
        docType: '',
        fileName: '',
        fileId: '',
      },
    ]);
  };

  const deleteDocField = (params, index, id) => {
    // console.log({ id });
    if (id !== '') {
      let payload = {
        fileId: id,
        applicationId: applId,
      };
      // console.log({ payload });

      props.apis.apiUnderWriterDeleteAdditionalDocs(payload).then((res) => {
        getUnderwriterInfo();
      });
    } else {
      let data = [...additionalDocFields];
      data.splice(index, 1);
      setAdditionalDocFields(data);
    }
  };

  const handleAdditionalDocsChange = (args, index) => {
    var documentNameInputCol = document.querySelector(`#column${index}-fileName`);
    var documentNameInput = document.querySelector(
      `#column${index}-fileName [name="additionalDoc.${index}.fileName"]`
    );

    // console.log(documentNameInputCol, documentNameInput);
    const hasOthers = args?.some((obj) => obj.key === 'OTHERS');
    if (hasOthers) {
      documentNameInputCol.classList.remove('d-none');
      documentNameInput.setAttribute('required', true);
    } else {
      documentNameInputCol.classList.add('d-none');
      documentNameInput.removeAttribute('required');
    }
  };

  const resolveResponse = (msg) => {
    swal2.fire({
      title: msg,
      icon: 'success',
      iconColor: '#DE3232',
      confirmButtonColor: '#DE3232',
      confirmButtonText: 'Close',
      timer: 3000,
    });
  };

  const handleAdditionalDocsSubmit = async (e, data) => {
    e.preventDefault();
    if (data) {
      let parsedPayload = parseInput(data);
      let payload = parsedPayload?.additionalDoc?.map((item) => {
        return {
          ...item,
          fileName: item?.fileName || item?.docType?.toTitleCase(),
          docType: item?.docType,
          category: 'CUSTOMER',
        };
      });

      const finalPayload = [];

      for (const obj of payload) {
        let reqdata = {
          file: obj.fileId,
        };
        let filePayload = {
          foldername: 'customerDocs',
          applicationId: applId,
          category: 'CUSTOMER',
        };

        const response = await props.apis.apiFileUploader(reqdata, filePayload).catch((err) => {
          if (err) {
            console.log({ err });
          }
        });
        const uploadFileResData = await response;

        const key = Object.keys(uploadFileResData)[0];
        const value = uploadFileResData[key];
        const newObj = { ...obj, fileId: value };

        finalPayload.push(newObj);
      }
      if (finalPayload) {
        console.log({ finalPayload });

        let applicationId = applId;
        props.apis
          .apiUpdateUnderWriterAdditionalDocs(finalPayload, {
            applicationId: applicationId,
          })
          .then((res) => {
            resolveResponse('Additional Documents Added Successfully');
            additionalDocForm?.current?.form?.current?.reset();
            getUnderwriterInfo();
            setAdditionalDocFields([
              {
                docType: '',
                fileName: '',
                fileId: '',
              },
            ]);
          });
      }
    }
  };

  const getUnderwriterInfo = () => {
    props.apis
      .apiGetUnderWriterApplicationDetails({
        applicationNumber: applId,
      })
      .then((res) => {
        if (res) {
          console.log({ res });
          if (res?.additionalDocsSubmitted) {
            setAdditionalDocs(
              res?.additionalDocsSubmitted?.filter(
                (v) => v.category === "CUSTOMER"
              )
            );
          }
        }
      });
  };

  useEffect(() => {
    getUnderwriterInfo();
  }, []);

  return (
    <>
      <div
        className={Object.className({
          'card profile_card p-4': true,
          'd-none': isReadonly ? true : false,
        })}
      >
        <div className="card-header p-0 border-0">
          <div className="d-flex align-items-center mb-3">
            <img src={imagepaths.cardGaurdIcon} alt="cardGaurdIcon" className="card_icon" />
            <h5 className="title ms-2 mb-0">Additional Documents</h5>
          </div>
        </div>
        <div className="py-4">
          <AppForm
            ref={additionalDocForm}
            onSubmit={(...args) => handleAdditionalDocsSubmit(...args)}
          >
            {additionalDocFields?.map((item, i) => (
              <div className="row" key={i}>
                <div className="col-12 col-md-3" id={`column${i}-docType`}>
                  <AppInput
                    name={`additionalDoc.${i}.docType`}
                    label="Document Type"
                    type="select"
                    options={_enum.DOC_TYPES_NEW_WITH_OTHERS}
                    onChange={(e) => handleAdditionalDocsChange(e, i)}
                    required
                  ></AppInput>
                </div>
                <div className="col-12 col-md-3 d-none" id={`column${i}-fileName`}>
                  <AppInput
                    name={`additionalDoc.${i}.fileName`}
                    label="Document Name"
                    type="text"
                    required
                  ></AppInput>
                </div>
                <div className="col-12 col-md-3" id={`column${i}-fileId`}>
                  <AppInput
                    name={`additionalDoc.${i}.fileId`}
                    label="Upload Document"
                    type="defaultfile"
                    fileLabel="Upload document"
                    foldername="underwriterDocs"
                    required
                  ></AppInput>
                </div>
                {i != 0 && (
                  <div
                    className={Object.className({
                      'col-12 col-md-3 d-flex align-items-center': true,
                    })}
                  >
                    <button
                      type="button"
                      onClick={(...args) => deleteDocField(...args, i, item?.fileId)}
                      className={Object.className({
                        'btn btn-primary mt-4': true,
                        'd-none': isReadonly,
                      })}
                    >
                      <i className="fa fa-trash"></i>
                    </button>
                  </div>
                )}
              </div>
            ))}
            <div className="action_btn_group mb-4 d-flex align-items-center justify-content-between">
              <button
                type="button"
                className={Object.className({
                  'btn btn-primary-transparent p-0 fs-5 border-right-0': true,
                  'd-none': isReadonly,
                })}
                onClick={(...args) => addMoreDocs(...args)}
              >
                + Add more document
              </button>
              <button type="submit" className="btn btn-primary">
                Submit
              </button>
            </div>
          </AppForm>

          {additionalDocs &&
            additionalDocs?.map((item, i) => {
              return (
                <div className="row" key={i}>
                  <div className="col-12 col-md-3">
                    <AppInput
                      name="docType"
                      label="Document Type"
                      defaultValue={item?.docType}
                      type="select"
                      options={_enum.DOC_TYPES_NEW_WITH_OTHERS}
                      required
                      disabled={true}
                    ></AppInput>
                  </div>
                  <div className="col-12 col-md-3">
                    <AppInput
                      name="fileName"
                      label="Document Name"
                      defaultValue={item?.fileName}
                      type="text"
                      required
                      disabled={true}
                    ></AppInput>
                  </div>
                  <div className="col-12 col-md-3">
                    <AppInput
                      name="fileId"
                      label="Upload Document"
                      type="file"
                      defaultValue={item?.fileId || ''}
                      fileLabel="Upload document"
                      foldername="underwriterDocs"
                      required
                      disabled={true}
                    ></AppInput>
                  </div>
                  <div
                    className={Object.className({
                      'col-12 col-md-3 d-flex align-items-center': true,
                    })}
                  >
                    <button
                      type="button"
                      onClick={(...args) => deleteDocField(...args, i, item?.fileId)}
                      className={Object.className({
                        'btn btn-primary': true,
                        'd-none': isReadonly,
                      })}
                    >
                      <i className="fa fa-trash"></i>
                    </button>
                  </div>
                </div>
              );
            })}
        </div>
      </div>
    </>
  );
};

export default constore(AdditionalDocs);
